import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'

import { useFieldArray } from 'react-hook-form'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

import styles from './HFInputs.module.sass'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import HFDropdown from './HFDropdown'
import HFTextInput from './HFTextInput'
import { RequisitionStatus } from 'utils/enums'

export const REQUESTED_APPROVED_STATES = [
	RequisitionStatus.Requested,
	RequisitionStatus.Executed,
	RequisitionStatus.AdministrativeApprove,
	RequisitionStatus.PartiallyApproved,
	RequisitionStatus.AcceptedByProvider,
	RequisitionStatus.OnGoing,
	RequisitionStatus.PendingExecution,
	RequisitionStatus.WaitingForSchedule,
]

const HFMedicalActsPresetProtocol = (props) => {
	const { name, data } = props

	const { i18n } = useGlobal()

	const { medicalActs } = data

	const { fields, append, remove } = useFieldArray({
		name,
		keyName: 'key',
	})

	return (
		<>
			<HStack gap='small' justify='space-between' columns={['75px', 4]}>
				<small>
					<strong>{i18n`Qtd.`}</strong>
				</small>
				<small>
					<strong>{i18n`Medical Acts`}</strong>
				</small>
			</HStack>
			{fields.map(({ key }, index) => {
				return (
					<HStack
						key={key}
						wrap='nowrap'
						gap='xsmall'
						className={styles['process-protocol-field']}
					>
						<HStack
							gap='small'
							justify='space-between'
							columns={['75px', 4]}
						>
							<HStack className={styles['quantity-container']}>
								<HFTextInput
									name={`${name}.${index}.quantity`}
									type='number'
									placeholder=''
									displaySuffixIcon={false}
									inputMode={'numeric'}
									multiline={false}
									noResize
									ignoreCustomValidity={false}
								/>
							</HStack>
							<div>
								<HFDropdown
									name={`${name}.${index}.medicalActId`}
									options={medicalActs || []}
									searchable={true}
									noData={i18n`No results`}
								/>
							</div>
						</HStack>
						<Icon
							className={styles['remove-button']}
							onClick={(e) => {
								e.preventDefault()
								remove(index)
							}}
							name='minus'
							height='12px'
							width='12px'
						/>
					</HStack>
				)
			})}
			<ActionButton
				className={styles['add-appointment-protocol']}
				secondary
				onClick={(e) => {
					e.preventDefault()
					append({
						quantity: 1,
						medicalActId: '',
						serviceProviderId: '',
					})
				}}
			>
				<Icon name='plus' height='14px' width='14px' />
				<small>{i18n`Add`}</small>
			</ActionButton>
		</>
	)
}

export default HFMedicalActsPresetProtocol
